import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Menu, Dropdown, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import styles from './Header.scss';

import SiteSearchContainer from '../../containers/SiteSearchContainer';

export class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const logo = (
      <svg viewBox="0 0 73 30" id="svg-icon-axs-logo" className="test-axs-logo">
        <g fillRule="evenodd">
          <path
            d="M61.174 10.103c-1.218-.321-2.664-.651-3.882-.98-.243-.067-3.048-.772-3.048-2.42 0-1.866 2.288-2.154 3.835-2.154 1.907 0 4.35.734 5.066 1.037.715.302.995.055 1.355-.375l2.237-2.683c.137-.164.134-.53-.246-.699 0 0-4.1-1.817-8.233-1.817-2.125 0-3.894.146-5.634.882-1.722.73-4.15 2.513-4.15 6.216 0 4.979 3.725 6.18 5.534 6.723 1.389.418 5.35 1.11 6.454 1.919.802.587 1.045 1.515.866 2.4-.21 1.039-1.393 1.941-4.226 1.941-2.263 0-3.726-.568-5.934-1.66-.571-.284-.647-.287-.99.117l-2.324 2.74c-.351.415-.605.742-.023 1.081 1.108.647 5.836 2.601 9.91 2.601 4.573 0 9.406-1.79 9.406-7.71 0-2.855-1.067-5.864-5.973-7.159zm9.822-8.24h-.386v-.408h.386a.2.2 0 0 1 .2.198c0 .11-.092.21-.2.21zm.605-.217a.569.569 0 0 0-.57-.565h-.782a.05.05 0 0 0-.05.05v1.73c0 .027.02.05.05.05h.31c.027 0 .05-.023.05-.05v-.666h.181l.348.693c.005.01.02.024.042.024h.348c.044 0 .062-.043.044-.076l-.358-.665c.227-.091.387-.285.387-.525zm-.755 1.897a1.528 1.528 0 0 1-1.527-1.527c0-.841.685-1.526 1.527-1.526.841 0 1.526.685 1.526 1.526 0 .842-.685 1.527-1.526 1.527zm0-3.543a2.016 2.016 0 1 0 0 4.033 2.016 2.016 0 0 0 0-4.033zM46.388 28.51L32.39 1.089c-.22-.432-.794-.784-1.28-.784H21.059c-.484 0-.624.3-.31.67l9.703 11.632-5.354 10.601c-.219.433 0 .787.484.787h2.847c.397 0 .628-.29.628-.29l5.373-6.328 9.281 11.134c.004.004.509.629 1.079.629h1.225c.163 0 .697.005.373-.63zM48.795.975c.314-.37.175-.67-.31-.67H38.292c-.364 0-.795.264-.96.588l-.805 1.606 3.218 9.148L48.795.975zM13.786 18.524c-.891 1.22-2.147 1.83-3.766 1.83-1.074 0-1.925-.313-2.552-.94-.627-.629-.941-1.472-.941-2.532 0-1.423.453-2.427 1.36-3.013.906-.585 3.79-.803 3.79-.803.55-.042 1.453-.076 2.004-.076h.44c.553 0 1.004.13 1.004.607 0 1.86-.447 3.707-1.339 4.927zM10.88 0C6.07 0 2.853 1.386 2.147 1.686c-.449.191-.423.555-.286.72l2.237 2.682c.495.592.78.578 1.241.417.013-.005 2.266-.966 5.54-.966 1.394 0 2.446.262 3.169.764.979.679.996 1.847 1.066 2.55.047.47-.44.724-.992.724h-3.243c-3.71 0-6.452.652-8.222 1.955C.886 11.837 0 13.855 0 16.588c0 2.526.742 4.492 2.228 5.9 1.486 1.409 3.612 2.114 6.224 2.114 2.628 0 4.817-.917 6.67-3.247.472-.592.787-.098.787-.098l2.083 2.448s.015.019.043.046a.85.85 0 0 0 .585.245h2.024c.353 0 .565-.19.568-.46v-12.91c0-3.988-.77-6.756-2.312-8.305C17.36.774 14.685 0 10.88 0z"
            mask="url(#avb)"
          />
        </g>
      </svg>
    );

    return (
      <div className={`test-site-header-container ${styles.header}`}>
        <div className={styles['header-logo-container']}>
          <Link
            to="/"
            className={`test-header-logo-link ${styles['header-logo']}`}
          >
            {logo} <span>EVENT TOOL</span>
          </Link>
        </div>
        <div className={styles['site-search-container']}>
          <SiteSearchContainer />
        </div>
        <Menu.Menu
          className={`test-user-dropdown-container ${styles['user-dropdown']}`}
        >
          <Dropdown
            item
            trigger={
              <span className="test-user-name">{this.props.UserName}!</span>
            }
            className={`dropdown-icon--white test-user-dropdown ${styles['header-dropdown']}`}
          >
            <Dropdown.Menu>
              <Dropdown.Item
                className="test-logout-link"
                as={Link}
                to={'/logout'}
              >
                <Icon className="test-logout-icon" name="sign out" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Menu.Menu>
      </div>
    );
  }
}
Header.propTypes = {
  UserName: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    UserName: state.app.UserName,
  };
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js